import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useShippingBoIntegrationDisconnect(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation<"delete", "/shops/{shopId}/integrations/shippingbo", void>(
    "delete",
    "/shops/{shopId}/integrations/shippingbo",
    {
      invalidate: invalidateShop,
      mapVariables: () => ({
        params: { path: { shopId: shop.id } },
      }),
    },
  );
}
